(function () {
  const STORAGE_KEY = 'bagveda:wishlist';
  const CHANGE_EVENT = 'bagveda:wishlist-change';

  const getHandles = () => {
    try {
      const raw = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      if (!Array.isArray(raw)) return [];
      return raw
        .map((item) => (typeof item === 'string' ? item : item && item.handle))
        .filter(Boolean);
    } catch (error) {
      return [];
    }
  };

  const setHandles = (handles) => {
    const unique = [...new Set(handles.filter(Boolean))];
    localStorage.setItem(STORAGE_KEY, JSON.stringify(unique));
    document.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: { handles: unique } }));
    return unique;
  };

  const hasHandle = (handle) => getHandles().includes(handle);

  const toggleHandle = (handle) => {
    if (!handle) return getHandles();
    const handles = getHandles();
    const index = handles.indexOf(handle);
    if (index >= 0) {
      handles.splice(index, 1);
    } else {
      handles.push(handle);
    }
    return setHandles(handles);
  };

  const removeHandle = (handle) => setHandles(getHandles().filter((item) => item !== handle));

  const syncButtons = () => {
    const handles = getHandles();
    document.querySelectorAll('[data-bagveda-wishlist-toggle]').forEach((button) => {
      const handle = button.getAttribute('data-product-handle');
      const active = handles.includes(handle);
      const isRemove = button.classList.contains('bagveda-wishlist-button--remove');
      button.classList.toggle('is-active', active && !isRemove);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  };

  const formatMoney = (cents, format) => {
    const value = Number(cents || 0) / 100;
    const formatted = value.toLocaleString('en-IN', {
      minimumFractionDigits: value % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2,
    });
    if (!format) return `₹${formatted}`;
    return format
      .replace(/\{\{\s*amount\s*\}\}/, formatted)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(value)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, formatted);
  };

  const escapeHtml = (value) =>
    String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');

  const productImage = (product) => {
    if (product.featured_image) {
      return product.featured_image.indexOf('//') === 0
        ? `https:${product.featured_image}`
        : product.featured_image;
    }
    if (product.images && product.images[0]) {
      const image = product.images[0];
      return image.indexOf('//') === 0 ? `https:${image}` : image;
    }
    return '';
  };

  const renderCard = (product, root) => {
    const variant = (product.variants && product.variants[0]) || {};
    const price = variant.price != null ? variant.price : product.price;
    const compare = variant.compare_at_price != null ? variant.compare_at_price : product.compare_at_price;
    const onSale = compare && Number(compare) > Number(price);
    const discount = onSale ? Math.round(((compare - price) / compare) * 100) : 0;
    const moneyFormat = root.getAttribute('data-money-format') || '';
    const moveLabel = root.getAttribute('data-move-label') || 'Move to Cart';
    const image = productImage(product);
    const url = product.url || `/products/${product.handle}`;
    const cartIcon = root.querySelector('[data-bagveda-wishlist-cart-icon]');
    const closeIcon = root.querySelector('[data-bagveda-wishlist-close-icon]');

    const article = document.createElement('article');
    article.className = 'bagveda-product-card bagveda-product-card--layout-wishlist';
    article.innerHTML = `
      <div class="bagveda-product-card__media bagveda-image-wrapper bagveda-image-wrapper--cover bagveda-image-wrapper--card">
        <a href="${escapeHtml(url)}" class="bagveda-product-card__media-link">
          ${
            image
              ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(product.title)}" width="291" height="327" loading="lazy">`
              : ''
          }
        </a>
        <div class="bagveda-product-card__wishlist">
          <button
            type="button"
            class="bagveda-wishlist-button bagveda-wishlist-button--remove"
            data-bagveda-wishlist-toggle
            data-product-handle="${escapeHtml(product.handle)}"
            aria-label="Remove ${escapeHtml(product.title)} from wishlist"
            aria-pressed="true"
          >
            <span class="svg-wrapper" aria-hidden="true">${closeIcon ? closeIcon.innerHTML : '×'}</span>
          </button>
        </div>
      </div>
      <div class="bagveda-product-card__meta">
        <a href="${escapeHtml(url)}" class="bagveda-product-card__meta-link">
          <div class="bagveda-product-card__title-wrap">
            <p class="bagveda-product-card__title">${escapeHtml(product.title)}</p>
          </div>
          <div class="bagveda-price bagveda-price-row">
            <span class="price">${formatMoney(price, moneyFormat)}</span>
            ${onSale ? `<span class="bagveda-badge bagveda-badge--discount">${discount}%</span>` : ''}
          </div>
        </a>
        <button
          type="button"
          class="bagveda-product-card__atc-btn bagveda-product-card__atc-btn--move"
          data-bagveda-move-to-cart
          data-variant-id="${escapeHtml(variant.id || '')}"
          data-product-handle="${escapeHtml(product.handle)}"
        >
          <span class="bagveda-product-card__atc-label">${escapeHtml(moveLabel)}</span>
          <span class="svg-wrapper" aria-hidden="true">
            ${cartIcon ? cartIcon.innerHTML : ''}
          </span>
        </button>
      </div>
    `;
    return article;
  };

  const renderPage = async (root) => {
    const grid = root.querySelector('[data-bagveda-wishlist-grid]');
    const empty = root.querySelector('[data-bagveda-wishlist-empty]');
    const countEl = root.querySelector('[data-bagveda-wishlist-count]');
    const countTemplate = root.getAttribute('data-count-label') || '[count] Product';
    if (!grid) return;

    let handles = getHandles();
    const sortValue = root.querySelector('[data-bagveda-wishlist-sort]')?.value || 'manual';

    const products = (
      await Promise.all(
        handles.map(async (handle) => {
          try {
            const response = await fetch(`/products/${encodeURIComponent(handle)}.js`);
            if (!response.ok) return null;
            return await response.json();
          } catch (error) {
            return null;
          }
        })
      )
    ).filter(Boolean);

    const missing = handles.filter((handle) => !products.some((product) => product.handle === handle));
    if (missing.length) {
      handles = setHandles(handles.filter((handle) => !missing.includes(handle)));
    }

    if (sortValue === 'title-ascending') {
      products.sort((a, b) => a.title.localeCompare(b.title));
    } else if (sortValue === 'title-descending') {
      products.sort((a, b) => b.title.localeCompare(a.title));
    } else if (sortValue === 'price-ascending') {
      products.sort((a, b) => Number(a.price) - Number(b.price));
    } else if (sortValue === 'price-descending') {
      products.sort((a, b) => Number(b.price) - Number(a.price));
    }

    grid.replaceChildren();
    products.forEach((product) => grid.appendChild(renderCard(product, root)));

    if (countEl) {
      countEl.textContent = countTemplate.replace('[count]', String(products.length));
    }

    const isEmpty = products.length === 0;
    if (empty) empty.hidden = !isEmpty;
    grid.hidden = isEmpty;
    root.classList.toggle('is-empty', isEmpty);
  };

  const translate = (key, fallback) =>
    (window.Theme && Theme.translations && Theme.translations[key]) || fallback;

  const isCartPage = () => {
    const cartUrl = (window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart';
    try {
      const path = new URL(cartUrl, window.location.origin).pathname.replace(/\/$/, '') || '/cart';
      return (window.location.pathname.replace(/\/$/, '') || '/') === path;
    } catch (error) {
      return false;
    }
  };

  let toastHideTimer;

  const hideCartToast = () => {
    const toast = document.getElementById('bagveda-cart-toast');
    if (toast) toast.classList.remove('is-visible');
  };

  const ensureCartToast = () => {
    let toast = document.getElementById('bagveda-cart-toast');
    if (toast) return toast;

    toast = document.createElement('div');
    toast.id = 'bagveda-cart-toast';
    toast.className = 'bagveda-cart-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.setAttribute('aria-atomic', 'true');

    const icon = document.createElement('span');
    icon.className = 'bagveda-cart-toast__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.innerHTML =
      '<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><circle cx="9" cy="9" r="8" stroke="currentColor" stroke-width="1.5"/><path d="M5.5 9.2L7.8 11.5L12.5 6.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    const message = document.createElement('p');
    message.className = 'bagveda-cart-toast__message';

    const link = document.createElement('a');
    link.className = 'bagveda-cart-toast__link';
    link.href = (window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart';

    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'bagveda-cart-toast__close';
    close.setAttribute('aria-label', translate('close', 'Close'));
    close.innerHTML = '<span aria-hidden="true">×</span>';
    close.addEventListener('click', hideCartToast);

    toast.append(icon, message, link, close);
    document.body.appendChild(toast);
    return toast;
  };

  const showCartToast = ({ error, message } = {}) => {
    if (!error && (isCartPage() || document.documentElement.classList.contains('bagveda-cart-open'))) {
      return;
    }

    const toast = ensureCartToast();
    const text = toast.querySelector('.bagveda-cart-toast__message');
    const link = toast.querySelector('.bagveda-cart-toast__link');
    if (text) {
      text.textContent = error
        ? message || translate('add_to_cart_error', 'Error adding to cart')
        : translate('added_to_cart', 'Added to cart');
    }
    if (link) {
      link.hidden = Boolean(error);
      link.textContent = translate('view_cart', 'View cart');
    }
    toast.classList.toggle('is-error', Boolean(error));
    toast.classList.remove('is-visible');
    void toast.offsetWidth;
    toast.classList.add('is-visible');
    window.clearTimeout(toastHideTimer);
    toastHideTimer = window.setTimeout(hideCartToast, error ? 5000 : 4000);
  };

  const ADD_TO_CART_SOURCES = {
    'bagveda-card-atc': true,
    'bagveda-wishlist-move': true,
    'bagveda-wishlist': true,
    'product-form-component': true,
  };

  const addToCart = async (variantId, source) => {
    const sourceId = source || 'bagveda-wishlist';
    if (!variantId) return false;

    const fail = (payload) => {
      showCartToast({
        error: true,
        message: payload && (payload.description || payload.message),
      });
      return false;
    };

    try {
      const response = await fetch((window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
      });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok || payload.status) return fail(payload);

      const cart = await fetch('/cart.js').then((res) => res.json()).catch(() => null);
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId,
            data: {
              itemCount: cart && cart.item_count,
              variantId,
              source: sourceId,
            },
          },
        })
      );
      return true;
    } catch (error) {
      return fail();
    }
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-bagveda-wishlist-toggle]');
    if (toggle) {
      event.preventDefault();
      event.stopPropagation();
      const handle = toggle.getAttribute('data-product-handle');
      toggleHandle(handle);
      return;
    }

    const move = event.target.closest('[data-bagveda-move-to-cart]');
    if (move) {
      event.preventDefault();
      move.classList.add('is-pressed');
      window.setTimeout(() => move.classList.remove('is-pressed'), 180);
      addToCart(move.getAttribute('data-variant-id'), 'bagveda-wishlist-move');
      return;
    }

    const cardAtc = event.target.closest('[data-bagveda-card-atc]');
    if (cardAtc) {
      event.preventDefault();
      event.stopPropagation();
      if (cardAtc.getAttribute('data-adding') === 'true') return;

      const btn = cardAtc.querySelector('.bagveda-product-card__atc-btn');
      if (btn) {
        btn.classList.add('is-pressed');
        window.setTimeout(() => btn.classList.remove('is-pressed'), 180);
      }

      const label = cardAtc.querySelector('.bagveda-product-card__atc-label');
      const originalLabel = label ? label.textContent : '';
      cardAtc.setAttribute('data-adding', 'true');
      addToCart(cardAtc.getAttribute('data-variant-id'), 'bagveda-card-atc')
        .then((ok) => {
          if (!ok || !label) return;
          label.textContent = translate('added', 'Added');
          window.setTimeout(() => {
            label.textContent = originalLabel;
          }, 2000);
        })
        .finally(() => cardAtc.removeAttribute('data-adding'));
    }
  });

  document.addEventListener('cart:update', (event) => {
    const detail = event.detail || {};
    const data = detail.data || {};
    if (data.didError) return;
    if (!ADD_TO_CART_SOURCES[data.source || detail.sourceId]) return;
    showCartToast();
  });

  document.addEventListener('cart:error', (event) => {
    if (isCartPage()) return;
    const data = (event.detail && event.detail.data) || {};
    showCartToast({ error: true, message: data.description || data.message });
  });

  document.addEventListener(CHANGE_EVENT, () => {
    syncButtons();
    const page = document.querySelector('[data-bagveda-wishlist-page]');
    if (page) renderPage(page);
  });

  document.addEventListener('DOMContentLoaded', () => {
    syncButtons();
    const page = document.querySelector('[data-bagveda-wishlist-page]');
    if (page) {
      const sortSelect = page.querySelector('[data-bagveda-wishlist-sort]');
      if (sortSelect) {
        sortSelect.addEventListener('change', () => renderPage(page));
      }
      renderPage(page);
    }
  });
})();
